import React, { useEffect, useState } from "react";
import { Col, Container, Row, Stack, Nav, Tab, Tabs, Button, Tooltip, OverlayTrigger } from "react-bootstrap";
import TODIS_FORM_GENERAL from "./form/NIWWPORTS/general";
import TODIS_FORM_INFRA from "./form/NSEAPORT/infrastructure";
import TODIS_FORM_OPS from "./form/NIWWPORTS/operations";
import TODIS_FORM_TENT_COMP from "./form/NIWWPORTS/tent_compliance";
import TODIS_FORM_MAINT from "./form/NIWWPORTS/maintenace";
import TODIS_FORM_ENV from "./form/GENERAL/environment";
import { TODIS_FORM_FIELD, TODIS_FORM_FIELD_YES_NO, TODIS_FORM_DSC } from "../../components/Forms";
import { BsExclamationCircleFill } from "react-icons/bs";
import TODIS_FORM_GENERAL_SEAPORT from "./form/NSEAPORT/general";
import TODIS_FORM_ENV_SEAPORT from "./form/NSEAPORT/environment";
import TODIS_FORM_OTHER_SEAPORT from "./form/NSEAPORT/other";
import { loadModules } from 'esri-loader';


const TODIS_FORM_SEAPORTS = ({ errors, touched, status, values, setFieldValue }) => {

    const [statusClean, setStatusClean] = useState(false)
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        try {
            const [Query, query] = loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/33";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_seaports_id=${values.npmSeaportsId}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            const results = query.executeQueryJSON(queryUrl, queryObject);

            if (results.features.length > 0) {
                setStatusTabDisabled(false);
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }

    })

    useEffect(() => {
        setFieldValue('seaportsNpmTentcompDTO.railConn', values.seaportsNpmInfraDTO.railConnection)
    }, [values.seaportsNpmInfraDTO.railConnection])

    useEffect(() => {
        setFieldValue('seaportsNpmTentcompDTO.roadConn', values.seaportsNpmInfraDTO.roadConnection)
    }, [values.seaportsNpmInfraDTO.roadConnection])

    useEffect(() => {
        if (values.tenTCategory == "5") {// Comprehensive  
            setFieldValue('seaportsNpmTentcompDTO.cleanFuelsAvai', "")
            setStatusClean(true)
        } else {// Core  
            setStatusClean(false)
        }
    }, [values.tenTCategory])

    useEffect(() => {
        setFieldValue('seaportsNpmTentcompDTO.vtmisDeploy', values.seaportsNpmInfraDTO.vtmis)
    }, [values.seaportsNpmInfraDTO.vtmis])

    const generalTooltip = (
        <Tooltip id="general-tooltip">
            General data
        </Tooltip>
    );

    const infraTooltip = (
        <Tooltip id="infra-tooltip">
            Infrastructure characteristics
        </Tooltip>
    );

    const tentTooltip = (
        <Tooltip id="tent-tooltip">
            Compliance with the relevant TEN-T standards
        </Tooltip>
    );

    const operationsTooltip = (
        <Tooltip id="operations-tooltip">
            Operations related data
        </Tooltip>
    );

    const safetyTooltip = (
        <Tooltip id="safety-tooltip">
            Safety related data
        </Tooltip>
    );

    const maintTooltip = (
        <Tooltip id="maint-tooltip">
            Maintenance related data
        </Tooltip>
    );

    const environmentTootltip = (
        <Tooltip id="environment-tooltip">
            Environment related data
        </Tooltip>
    );

    const otherTootltip = (
        <Tooltip id="other-tooltip">
            Other parameters related data
        </Tooltip>
    );

    return (

        <Tabs defaultActiveKey="General" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">


            <Tab eventKey="General" title={
                <OverlayTrigger placement="bottom" overlay={generalTooltip}>
                    <div>General</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_GENERAL_SEAPORT errors={errors} touched={touched} disabled={status} TypeForm="" setFieldValue={setFieldValue} values={values} />
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="remarks" label="Remarks" name="remarks" disabled={status} />
                            {errors.remarks && touched.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="section 3" title={
                <OverlayTrigger placement="bottom" overlay={infraTooltip}>
                    <div>Infrastructure</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_INFRA errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmInfraDTO" sectionData={values.seaportsNpmInfraDTO} setFieldValue={setFieldValue} values={values} />
            </Tab>
            <Tab eventKey="TENT" title={
                <OverlayTrigger placement="bottom" overlay={tentTooltip}>
                    <div>TEN-T Compliance</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_TENT_COMP errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmTentcompDTO" statusClean={statusClean} />
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.vtmisDeploy" label="VTMIS Deployment" name="seaportsNpmTentcompDTO.vtmisDeploy" disabled={true} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.vtmisDeploy && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.vtmisDeploy ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.vtmisDeploy}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.iwwCemtConn" label="Seaport/ CEMT Connection" name="seaportsNpmTentcompDTO.iwwCemtConn" disabled={status} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.iwwCemtConn && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.iwwCemtConn ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.iwwCemtConn}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.wasteFacilities" label="Waste facilities" name="seaportsNpmTentcompDTO.wasteFacilities" disabled={status} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.wasteFacilities && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.wasteFacilities ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.wasteFacilities}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.intermodalUnitsHandling" label="Intermodal units handling" name="seaportsNpmTentcompDTO.intermodalUnitsHandling" disabled={false} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.intermodalUnitsHandling && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.intermodalUnitsHandling ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.intermodalUnitsHandling}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.safeSeaNet" label="SafeSeaNet" name="seaportsNpmTentcompDTO.safeSeaNet" disabled={false} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.safeSeaNet && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.safeSeaNet ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.safeSeaNet}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.maritimeNSW" label="MaritimeNSW" name="seaportsNpmTentcompDTO.maritimeNSW" disabled={false} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.maritimeNSW && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.maritimeNSW ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.maritimeNSW}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.alternativeFuelsElectricity" label="Alternative Fuels Electricity" name="seaportsNpmTentcompDTO.alternativeFuelsElectricity" disabled={false} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.alternativeFuelsElectricity && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.alternativeFuelsElectricity ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.alternativeFuelsElectricity}</div>) : null}
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD_YES_NO id="seaportsNpmTentcompDTO.alternativeFuelsMethane" label="Alternative Fuels Methane" name="seaportsNpmTentcompDTO.alternativeFuelsMethane" disabled={false} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.alternativeFuelsMethane && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.alternativeFuelsMethane ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.alternativeFuelsMethane}</div>) : null}
                        </Col>
                        <Col lg={12}>
                            <TODIS_FORM_DSC id="seaportsNpmTentcompDTO.remarks" label="Remarks" name="seaportsNpmTentcompDTO.remarks" disabled={status} />
                            {errors.seaportsNpmTentcompDTO && errors.seaportsNpmTentcompDTO.remarks && touched.seaportsNpmTentcompDTO && touched.seaportsNpmTentcompDTO.remarks ? (<div className="todis-field-validation-err"><span className="todis-field-validation-err-icon"><BsExclamationCircleFill size={20} /></span>Error: {errors.seaportsNpmTentcompDTO.remarks}</div>) : null}
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Operations" title={
                <OverlayTrigger placement="bottom" overlay={operationsTooltip}>
                    <div>Operations</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_OPS errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmOpsDTO" />
            </Tab>
            <Tab eventKey="Maintenance" title={
                <OverlayTrigger placement="bottom" overlay={maintTooltip}>
                    <div>Maintenance</div>
                </OverlayTrigger>
            }>
                <TODIS_FORM_MAINT errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmMaintDTO" />
            </Tab>
            <Tab eventKey="Environmental" title={
                <OverlayTrigger placement="bottom" overlay={environmentTootltip}>
                    <div>Environmental Impact</div>
                </OverlayTrigger>
            }>
                <Container>
                    <Row>
                        <TODIS_FORM_ENV_SEAPORT errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmEnvDTO" />
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Other" title={
                    <OverlayTrigger placement="bottom" overlay={otherTootltip}>
                        <div>Others</div>
                    </OverlayTrigger>
                }>
                    <Container>
                        <Row>
                            <TODIS_FORM_OTHER_SEAPORT errors={errors} touched={touched} disabled={status} TypeForm="seaportsNpmOtherDTO" values={values} />
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default TODIS_FORM_SEAPORTS;